// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23dcca98%27 fill-opacity=%270.05%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tools {
    padding: 100px 0;
    background: linear-gradient(135deg, #0a2e2e 0%, #114040 50%, #0f2f2f 100%);
    position: relative;
    overflow: hidden;
  }
  
  /* Add subtle pattern overlay */
  #tools::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    opacity: 0.8;
    z-index: 1;
    pointer-events: none;
  }
  
  .tools-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
  }
  
  .tools-section-title {
    margin-bottom: 60px;
    position: relative;
    opacity: 0;
    transform: translateY(30px);
    transition: all 0.8s ease;
  }
  
  .animate-section .tools-section-title {
    opacity: 1;
    transform: translateY(0);
  }
  
  .tools-section-title h2 {
    font-size: 3.2rem;
    font-weight: 700;
    margin-bottom: 25px;
    color: #dcca98;
    text-align: center;
    letter-spacing: 2px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    position: relative;
    display: inline-block;
  }
  
  .tools-section-title h2::after {
    content: '';
    position: absolute;
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #dcca98, transparent);
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .tools-section-title p {
    color: #f4e9c0;
    font-size: 1.25rem;
    max-width: 640px;
    margin: 0 auto 40px;
    line-height: 1.6;
    font-weight: 300;
  }
  
  /* GRID */
  .tools-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    margin-top: 40px;
  }
  
  /* Card container with animations */
  .tool-card-container {
    opacity: 0;
    transform: translateY(40px);
    transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  
  .animate-section .tool-card-container {
    opacity: 1;
    transform: translateY(0);
  }
  
  /* Staggered animation delays */
  .animate-section .slide-up-1 {
    transition-delay: 0.1s;
  }
  
  .animate-section .slide-up-2 {
    transition-delay: 0.2s;
  }
  
  .animate-section .slide-up-3 {
    transition-delay: 0.3s;
  }
  
  .animate-section .slide-up-4 {
    transition-delay: 0.4s;
  }
  
  /* Floating animation */
  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-8px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  
  /* Apply floating animation to cards after they've appeared */
  .animate-section .tool-card-container:hover {
    animation: float 3s ease-in-out infinite;
  }
  
  /* PREVIEW CARD */
  .tool-preview-card {
    background-color: #fffbe6;
    border-radius: 16px;
    padding: 30px 20px;
    position: relative;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    overflow: hidden;
    text-align: center;
  }
  
  .tool-preview-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 20px rgba(220, 202, 152, 0.3);
  }
  
  .tool-icon img {
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
    object-fit: contain;
    filter: drop-shadow(0 0 4px #ddd);
  }
  
  .tool-preview-card h3 {
    font-size: 1.3rem;
    color: #114040;
    margin-bottom: 10px;
  }
  
  .tool-preview-card p {
    font-size: 0.95rem;
    color: #333;
    margin: 0 auto;
    line-height: 1.4;
  }
  
  /* Hover Reveal */
  .tool-preview-card .hover-reveal {
    opacity: 0;
    transition: opacity 0.3s ease;
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
    font-size: 0.85rem;
    color: #555;
    background: rgba(255, 255, 255, 0.95);
    padding: 10px;
    border-radius: 12px;
  }
  
  .tool-preview-card:hover .hover-reveal {
    opacity: 1;
  }
  
  /* RESPONSIVE */
  @media (max-width: 1200px) {
    .tools-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 25px;
    }
    
    .tools-section-title h2 {
      font-size: 2.8rem;
    }
  }
  
  @media (max-width: 991px) {
    #tools {
      padding: 80px 0;
    }
    
    .tools-grid {
      margin-top: 30px;
    }
    
    .tools-section-title {
      margin-bottom: 40px;
    }
    
    .tools-section-title h2 {
      font-size: 2.6rem;
      letter-spacing: 1.5px;
    }
    
    .tools-section-title p {
      font-size: 1.15rem;
      margin-bottom: 30px;
    }
  }
  
  @media (max-width: 768px) {
    .tools-section-title h2 {
      font-size: 2.5rem;
      letter-spacing: 1px;
    }
    
    .tools-section-title p {
      font-size: 1.1rem;
      max-width: 100%;
      padding: 0 10px;
    }
    
    /* Adjust animation for touch devices */
    .animate-section .tool-card-container:hover {
      animation: none; /* Disable floating on touch devices */
    }
    
    .tools-grid {
      gap: 20px;
    }
  }
  
  @media (max-width: 600px) {
    #tools {
      padding: 60px 0;
    }
    
    .tools-grid {
      grid-template-columns: 1fr;
      gap: 25px;
    }
    
    .tools-section-title h2 {
      font-size: 2rem;
    }
    
    .tools-section-title h2::after {
      width: 50px;
      height: 2px;
    }
    
    .tools-section-title {
      margin-bottom: 30px;
    }
    
    /* Reduce stagger time for better mobile UX */
    .animate-section .slide-up-1,
    .animate-section .slide-up-2,
    .animate-section .slide-up-3,
    .animate-section .slide-up-4 {
      transition-delay: 0.1s;
    }
  }
  
  @media (max-width: 480px) {
    .tools-container {
      padding: 0 15px;
    }
    
    .tools-section-title h2 {
      font-size: 1.8rem;
    }
    
    .tools-section-title p {
      font-size: 1rem;
    }
    
    .tools-grid {
      gap: 20px;
    }
  }
  
  /* Fix for iOS Safari and some Android browsers */
  @supports (-webkit-touch-callout: none) {
    .tool-card-container {
      transform: translate3d(0, 40px, 0);
    }
    
    .animate-section .tool-card-container {
      transform: translate3d(0, 0, 0);
    }
  }
  
  .tool-card-container.mobile {
    transform: translateY(0);
    opacity: 1;
    transition-delay: 0.1s !important;
  }
  
  /* Touch-specific optimizations */
  @media (hover: none) {
    .animate-section .tool-card-container {
      transition: opacity 0.5s ease-out;
      transform: translateY(0);
    }
    
    /* Reduce animation complexity on mobile for better performance */
    .animate-section .tool-card-container:hover,
    .animate-section .tool-card-container:active {
      animation: none;
    }
    
    /* Ensure elements are visible on touch without animations */
    .tools-section-title {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* iOS-specific fixes */
  @supports (-webkit-touch-callout: none) {
    #tools {
      -webkit-backface-visibility: hidden;
      -webkit-perspective: 1000;
    }
    
    .tools-section-title {
      backface-visibility: hidden;
    }
    
    .tool-card-container {
      -webkit-transform: translate3d(0, 40px, 0);
    }
    
    .animate-section .tool-card-container,
    .tool-card-container.mobile {
      -webkit-transform: translate3d(0, 0, 0);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/home/Tools/tools.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,+BAA+B;EAC/B;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yDAAoY;IACpY,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,wDAAwD;IACxD,aAAa;IACb,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,SAAS;EACT;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;IACE,UAAU;IACV,2BAA2B;IAC3B,4DAA4D;EAC9D;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA,+BAA+B;EAC/B;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,uBAAuB;EACvB;IACE;MACE,0BAA0B;IAC5B;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,0BAA0B;IAC5B;EACF;;EAEA,6DAA6D;EAC7D;IACE,wCAAwC;EAC1C;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,qDAAqD;IACrD,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,gDAAgD;EAClD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,qCAAqC;IACrC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA,eAAe;EACf;IACE;MACE,qCAAqC;MACrC,SAAS;IACX;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;MACjB,qBAAqB;IACvB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,eAAe;IACjB;;IAEA,uCAAuC;IACvC;MACE,eAAe,EAAE,sCAAsC;IACzD;;IAEA;MACE,SAAS;IACX;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;MAC1B,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,WAAW;IACb;;IAEA;MACE,mBAAmB;IACrB;;IAEA,6CAA6C;IAC7C;;;;MAIE,sBAAsB;IACxB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,SAAS;IACX;EACF;;EAEA,iDAAiD;EACjD;IACE;MACE,kCAAkC;IACpC;;IAEA;MACE,+BAA+B;IACjC;EACF;;EAEA;IACE,wBAAwB;IACxB,UAAU;IACV,iCAAiC;EACnC;;EAEA,iCAAiC;EACjC;IACE;MACE,iCAAiC;MACjC,wBAAwB;IAC1B;;IAEA,iEAAiE;IACjE;;MAEE,eAAe;IACjB;;IAEA,4DAA4D;IAC5D;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA,uBAAuB;EACvB;IACE;MACE,mCAAmC;MACnC,yBAAyB;IAC3B;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,0CAA0C;IAC5C;;IAEA;;MAEE,uCAAuC;IACzC;EACF","sourcesContent":["#tools {\n    padding: 100px 0;\n    background: linear-gradient(135deg, #0a2e2e 0%, #114040 50%, #0f2f2f 100%);\n    position: relative;\n    overflow: hidden;\n  }\n  \n  /* Add subtle pattern overlay */\n  #tools::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23dcca98' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n    opacity: 0.8;\n    z-index: 1;\n    pointer-events: none;\n  }\n  \n  .tools-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 2;\n  }\n  \n  .tools-section-title {\n    margin-bottom: 60px;\n    position: relative;\n    opacity: 0;\n    transform: translateY(30px);\n    transition: all 0.8s ease;\n  }\n  \n  .animate-section .tools-section-title {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  \n  .tools-section-title h2 {\n    font-size: 3.2rem;\n    font-weight: 700;\n    margin-bottom: 25px;\n    color: #dcca98;\n    text-align: center;\n    letter-spacing: 2px;\n    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n    position: relative;\n    display: inline-block;\n  }\n  \n  .tools-section-title h2::after {\n    content: '';\n    position: absolute;\n    width: 60px;\n    height: 3px;\n    background: linear-gradient(90deg, #dcca98, transparent);\n    bottom: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  .tools-section-title p {\n    color: #f4e9c0;\n    font-size: 1.25rem;\n    max-width: 640px;\n    margin: 0 auto 40px;\n    line-height: 1.6;\n    font-weight: 300;\n  }\n  \n  /* GRID */\n  .tools-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 30px;\n    margin-top: 40px;\n  }\n  \n  /* Card container with animations */\n  .tool-card-container {\n    opacity: 0;\n    transform: translateY(40px);\n    transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  }\n  \n  .animate-section .tool-card-container {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  \n  /* Staggered animation delays */\n  .animate-section .slide-up-1 {\n    transition-delay: 0.1s;\n  }\n  \n  .animate-section .slide-up-2 {\n    transition-delay: 0.2s;\n  }\n  \n  .animate-section .slide-up-3 {\n    transition-delay: 0.3s;\n  }\n  \n  .animate-section .slide-up-4 {\n    transition-delay: 0.4s;\n  }\n  \n  /* Floating animation */\n  @keyframes float {\n    0% {\n      transform: translateY(0px);\n    }\n    50% {\n      transform: translateY(-8px);\n    }\n    100% {\n      transform: translateY(0px);\n    }\n  }\n  \n  /* Apply floating animation to cards after they've appeared */\n  .animate-section .tool-card-container:hover {\n    animation: float 3s ease-in-out infinite;\n  }\n  \n  /* PREVIEW CARD */\n  .tool-preview-card {\n    background-color: #fffbe6;\n    border-radius: 16px;\n    padding: 30px 20px;\n    position: relative;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    cursor: pointer;\n    overflow: hidden;\n    text-align: center;\n  }\n  \n  .tool-preview-card:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 12px 20px rgba(220, 202, 152, 0.3);\n  }\n  \n  .tool-icon img {\n    width: 80px;\n    height: 80px;\n    margin-bottom: 20px;\n    object-fit: contain;\n    filter: drop-shadow(0 0 4px #ddd);\n  }\n  \n  .tool-preview-card h3 {\n    font-size: 1.3rem;\n    color: #114040;\n    margin-bottom: 10px;\n  }\n  \n  .tool-preview-card p {\n    font-size: 0.95rem;\n    color: #333;\n    margin: 0 auto;\n    line-height: 1.4;\n  }\n  \n  /* Hover Reveal */\n  .tool-preview-card .hover-reveal {\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    position: absolute;\n    bottom: 20px;\n    left: 20px;\n    right: 20px;\n    font-size: 0.85rem;\n    color: #555;\n    background: rgba(255, 255, 255, 0.95);\n    padding: 10px;\n    border-radius: 12px;\n  }\n  \n  .tool-preview-card:hover .hover-reveal {\n    opacity: 1;\n  }\n  \n  /* RESPONSIVE */\n  @media (max-width: 1200px) {\n    .tools-grid {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 25px;\n    }\n    \n    .tools-section-title h2 {\n      font-size: 2.8rem;\n    }\n  }\n  \n  @media (max-width: 991px) {\n    #tools {\n      padding: 80px 0;\n    }\n    \n    .tools-grid {\n      margin-top: 30px;\n    }\n    \n    .tools-section-title {\n      margin-bottom: 40px;\n    }\n    \n    .tools-section-title h2 {\n      font-size: 2.6rem;\n      letter-spacing: 1.5px;\n    }\n    \n    .tools-section-title p {\n      font-size: 1.15rem;\n      margin-bottom: 30px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .tools-section-title h2 {\n      font-size: 2.5rem;\n      letter-spacing: 1px;\n    }\n    \n    .tools-section-title p {\n      font-size: 1.1rem;\n      max-width: 100%;\n      padding: 0 10px;\n    }\n    \n    /* Adjust animation for touch devices */\n    .animate-section .tool-card-container:hover {\n      animation: none; /* Disable floating on touch devices */\n    }\n    \n    .tools-grid {\n      gap: 20px;\n    }\n  }\n  \n  @media (max-width: 600px) {\n    #tools {\n      padding: 60px 0;\n    }\n    \n    .tools-grid {\n      grid-template-columns: 1fr;\n      gap: 25px;\n    }\n    \n    .tools-section-title h2 {\n      font-size: 2rem;\n    }\n    \n    .tools-section-title h2::after {\n      width: 50px;\n      height: 2px;\n    }\n    \n    .tools-section-title {\n      margin-bottom: 30px;\n    }\n    \n    /* Reduce stagger time for better mobile UX */\n    .animate-section .slide-up-1,\n    .animate-section .slide-up-2,\n    .animate-section .slide-up-3,\n    .animate-section .slide-up-4 {\n      transition-delay: 0.1s;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .tools-container {\n      padding: 0 15px;\n    }\n    \n    .tools-section-title h2 {\n      font-size: 1.8rem;\n    }\n    \n    .tools-section-title p {\n      font-size: 1rem;\n    }\n    \n    .tools-grid {\n      gap: 20px;\n    }\n  }\n  \n  /* Fix for iOS Safari and some Android browsers */\n  @supports (-webkit-touch-callout: none) {\n    .tool-card-container {\n      transform: translate3d(0, 40px, 0);\n    }\n    \n    .animate-section .tool-card-container {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  \n  .tool-card-container.mobile {\n    transform: translateY(0);\n    opacity: 1;\n    transition-delay: 0.1s !important;\n  }\n  \n  /* Touch-specific optimizations */\n  @media (hover: none) {\n    .animate-section .tool-card-container {\n      transition: opacity 0.5s ease-out;\n      transform: translateY(0);\n    }\n    \n    /* Reduce animation complexity on mobile for better performance */\n    .animate-section .tool-card-container:hover,\n    .animate-section .tool-card-container:active {\n      animation: none;\n    }\n    \n    /* Ensure elements are visible on touch without animations */\n    .tools-section-title {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  /* iOS-specific fixes */\n  @supports (-webkit-touch-callout: none) {\n    #tools {\n      -webkit-backface-visibility: hidden;\n      -webkit-perspective: 1000;\n    }\n    \n    .tools-section-title {\n      backface-visibility: hidden;\n    }\n    \n    .tool-card-container {\n      -webkit-transform: translate3d(0, 40px, 0);\n    }\n    \n    .animate-section .tool-card-container,\n    .tool-card-container.mobile {\n      -webkit-transform: translate3d(0, 0, 0);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
